import { useNavigate, Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import {
  ArrowLeft,
  ArrowRight,
  Gamepad2,
  Shield,
  CreditCard,
  Users,
  ScrollText,
} from 'lucide-react';

const adminLinks = [
  {
    label: 'Games',
    description: 'Register and manage game configurations',
    icon: Gamepad2,
    path: '/a/arche_game_rewards/admin/games',
  },
  {
    label: 'Rules & Limits',
    description: 'Configure reward type rate limits',
    icon: Shield,
    path: '/a/arche_game_rewards/admin/limits',
  },
  {
    label: 'Tiers',
    description: 'Manage subscription tier pricing',
    icon: CreditCard,
    path: '/a/arche_game_rewards/admin/tiers',
  },
  {
    label: 'Subscriptions',
    description: 'View and manage user subscriptions',
    icon: Users,
    path: '/a/arche_game_rewards/admin/subscriptions',
  },
  {
    label: 'Reward Log',
    description: 'Full audit log of all reward deliveries',
    icon: ScrollText,
    path: '/a/arche_game_rewards/admin/reward-log',
  },
];

export function AdminDashboardPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <div>
        <Link
          to="/a/arche_game_rewards"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-2"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to Dashboard
        </Link>
        <h1 className="text-2xl font-semibold">Admin Dashboard</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage game reward system configuration
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {adminLinks.map((link) => {
          const Icon = link.icon;
          return (
            <Card
              key={link.path}
              className="hover:bg-muted/50 transition-colors cursor-pointer"
              onClick={() => navigate(link.path)}
            >
              <CardContent className="flex items-center justify-between py-6">
                <div className="flex items-center gap-3">
                  <Icon className="h-5 w-5 text-muted-foreground" />
                  <div>
                    <p className="font-medium">{link.label}</p>
                    <p className="text-sm text-muted-foreground">{link.description}</p>
                  </div>
                </div>
                <ArrowRight className="h-4 w-4 text-muted-foreground" />
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
